import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { FormulariosWizardStore } from './formularios-wizard.store';

// Step alvo a partir da rota-filha ativada ('' → informações/1, 'perguntas' → 2). Suporta deep-link
// direto no step de perguntas.
const stepFromChild = (route: ActivatedRouteSnapshot): number =>
  route.firstChild?.routeConfig?.path === 'perguntas' ? 2 : 1;

/**
 * Resolver de `/formularios/editar/:id`. Roda na ativação da rota-pai (não entre os steps-filhos,
 * preservando a navegação interna do wizard). Se está reentrando no MESMO form já carregado,
 * preserva o estado e só ajusta o step; se é um form diferente (ou 1ª carga), limpa o estado da
 * sessão anterior e recarrega. Necessário porque o store sobrevive à navegação SPA (o
 * EnvironmentInjector da rota não é reciclado) e carregaria o step/dados da edição anterior.
 */
export const editFormularioResolver: ResolveFn<boolean> = (route) => {
  const store = inject(FormulariosWizardStore);
  const router = inject(Router);

  const idParam = route.paramMap.get('id');
  const id = idParam ? parseInt(idParam, 10) : NaN;
  if (isNaN(id)) {
    router.navigate(['/formularios']);
    return of(false);
  }

  const targetStep = stepFromChild(route);

  if (store.id() === id) {
    store.setStep(targetStep);
    return true;
  }

  store.reset();
  return store.loadForm(id, targetStep);
};

/**
 * Resolver de `/formularios/novo`. Limpa o estado do wizard ao iniciar uma criação nova, para não
 * herdar step/dados de uma edição ou criação anterior. Simétrico ao editFormularioResolver.
 */
export const newFormularioResolver: ResolveFn<boolean> = () => {
  inject(FormulariosWizardStore).reset();
  return true;
};
